const API_URL   = process.env.VUE_APP_API_URL;
const SECRET    = process.env.VUE_APP_PORTAL_WEBHOOK_SECRET || '';

function beacon(endpoint, payload) {
    const url  = API_URL + endpoint;
    const blob = new Blob([JSON.stringify({ ...payload, secret: SECRET })], {
        type: 'application/json',
    });
    navigator.sendBeacon(url, blob);
}

export function sendAbandonmentBeacon(debtorId, ownerId, phoneNumber, eventType) {
    if (!debtorId || !ownerId) return;
    beacon('portal-event/abandonment', { debtorId, ownerId, phoneNumber: phoneNumber || null, eventType });
}

export function sendAgreementCompletedBeacon(debtorId, ownerId) {
    if (!debtorId || !ownerId) return;
    beacon('portal-event/agreement-completed', { debtorId, ownerId });
}
